import createAxios from './http'

import getSign from '@/core'
import {getSecret, getKey } from '@/common/js/cache'
import encryptPhone from '@/core/phone'

const request = createAxios()

/**
* 拦截请求
*
*/
request.interceptors.request.use(
  config => {
    const accessSecret = getSecret()
    const accessKey = getKey()

    const timestamp = (new Date()).valueOf()
    config.params = config.params || {}
    const params = config.params

    const signParams = {
      ...params,
      timestamp,
      accessKey
    }

    const sign = getSign(signParams, accessSecret)
    config.params.timestamp = timestamp
    config.params.accessKey = accessKey
    config.params.sign = sign
    return config
  },
  err => {
    return Promise.reject(err)
  }
)


export function bindKin (params) {
  params.phone = encryptPhone(params.phone)
  return request({
    url: '/ordercorrelation/addOrderCorrelationKinsfolk.htm',
    method: 'post',
    params
  })
}
export function bindOrderList (params) {
  return request({
    url: '/ordercorrelation/getOrderCorrelationKinsfolk.htm',
    method: 'post',
    params
  })
}

